import can from 'can';
import playerBioTemplate from './player-bio.stache';
import dayjs from 'dayjs';

can.Component.extend({
    tag: 'player-bio',
    template: playerBioTemplate,
    viewModel: {
        define: {
            data: {
                Type: can.Map,
                Value: can.Map,
            },
            age: {
                type: 'number',
                get() {
                    const bd = dayjs(this.data.birthDate, 'MM/DD/YYYY');
                    if (!bd.isValid()) {
                        console.log('Birth date is not correct...');
                        return '';
                    }
                    return dayjs().diff(bd, 'years');
                },
            },
        },
    },
});
